export function isSpecialRequirementsField(id: string) {
    return id === 'SPECIAL_REQUIREMENTS';
}
